import { render, staticRenderFns } from "./LinkInventoryToOrderModal.vue?vue&type=template&id=6f9e11c9"
import script from "./LinkInventoryToOrderModal.vue?vue&type=script&lang=ts"
export * from "./LinkInventoryToOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports